import React, { useState } from 'react';
import FilterButton from '../../../../components/common/FilterButton';
import { FilterCondition } from '../../../../types/filter';
import DownloadCSVButton from '../../../../components/common/DownloadCSVButton';
import LeadsDropdown from './LeadsDropdown';
import Sort from '../../../../components/common/Sort';

interface FilterBarProps {
  onDownloadCSV: () => void;
  isDownloading?: boolean;
  onSortChange: (option: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ onDownloadCSV, isDownloading, onSortChange }) => {
  const [showSearch, setShowSearch] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterConditions, setFilterConditions] = useState<FilterCondition[]>([{
    column: '',
    operator: '',
    value: ''
  }]);

  const filterConfig = {
    columns: ['Company name', 'Intent signals', 'Categories'],
    conditions: filterConditions,
    onConditionsChange: (newConditions: FilterCondition[]) => {
      setFilterConditions(newConditions);
      console.log('Applied filters:', newConditions);
    }
  };

  return (
    <div className='flex flex-col'>
      <div className="flex justify-between bg-[#FFFFFF] items-center py-[10px] px-6 border-b border-[#EEEEEE]">
        <div className='flex items-start'>
          <div>
            <LeadsDropdown onClick={onDownloadCSV} totalLeads={0} />
          </div>
        </div>
        <div className='flex items-end'>
          <div>
            <DownloadCSVButton onClick={onDownloadCSV} isLoading={isDownloading} />
          </div>
        </div>
      </div>
      <div className='flex items-center bg-white py-[10px] px-6 border-b border-[#EEEEEE] gap-2'>
        <div className='flex items-center'>
          <Sort onSortChange={onSortChange} />
        </div>
        {/* <div className="text-[#DDDDDD] text-[18px] text-center pb-[4px] font-thin">|</div>
        <div className='flex items-center'>
          <div>
            <FilterButton filterConfig={filterConfig} />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default FilterBar; 